<template>
  <modal
    class="likes"
    :name="'share-modal-' + post.postId"
    width="90%"
    height="90%"
  >
    <Button
      class="close"
      @click.native="$modal.hide('share-modal-' + post.postId)"
      margin="10px"
      color="#31b9be"
      bgcolor="transparent"
      width="30px"
      padding="0"
      icon="close-blue"
    ></Button>

    {{ post }}

    <div>
      <Button bgcolor="#4267B2" color="#fff">
        <ShareNetwork
          class="sharebutton"
          network="facebook"
          url="https://neoparent.be/"
          :title="post.title"
          :description="post.content"
          :quote="post.content"
        >
          <span>Share on Facebook</span>
        </ShareNetwork>
      </Button>
    </div>
  </modal>
</template>

<script>
export default {
  name: "ShareModal",
  props: {
    post: { type: Object, required: true }
  }
};
</script>
